import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26088b5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "cancel",
  class: "box_sso cancel"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_table" }
const _hoisted_4 = { class: "cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SSOBackground = _resolveComponent("SSOBackground")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_IdcardOutlined = _resolveComponent("IdcardOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_MobileOutlined = _resolveComponent("MobileOutlined")!
  const _component_SafetyCertificateOutlined = _resolveComponent("SafetyCertificateOutlined")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_SSOBackground),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_a_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { xs: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form, {
                    ref: "form",
                    model: $data.form.data,
                    rules: $data.form.rule
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_typography_title, { level: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 账号注销 ")
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_a_alert, {
                        type: "warning",
                        "show-icon": ""
                      }, {
                        message: _withCtx(() => [
                          _createTextVNode(" 注销申请提交后，账号会进入注销缓冲期 ")
                        ]),
                        description: _withCtx(() => [
                          _createTextVNode(" 缓冲期内账号无法登录，手机号和邮箱不能绑定到其他账号；缓冲期结束后，账号及相关数据将无法找回。若误操作，可在登录时按提示终止注销。 ")
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_a_form_item, {
                        name: "uid",
                        "has-feedback": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: $data.form.data.uid,
                            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($data.form.data.uid) = $event)),
                            placeholder: "用户ID",
                            maxlength: _ctx.$Check.Constraint.Max2X,
                            "show-count": $data.form.data.uid.length>0,
                            disabled: ""
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_IdcardOutlined, { class: "input_icon" })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_a_form_item, {
                        name: "phone",
                        "has-feedback": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: $data.form.data.phone,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($data.form.data.phone) = $event)),
                            placeholder: "手机号",
                            maxlength: _ctx.$Check.Constraint.Phone,
                            "show-count": $data.form.data.phone.length>0,
                            "allow-clear": ""
                          }, {
                            prefix: _withCtx(() => [
                              _createVNode(_component_MobileOutlined, { class: "input_icon" })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_a_row, { class: "box_auth" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 13 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                name: "code",
                                "has-feedback": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input, {
                                    value: $data.form.data.code,
                                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (($data.form.data.code) = $event)),
                                    placeholder: "验证码",
                                    maxlength: _ctx.$Check.Constraint.AuthX,
                                    "show-count": $data.form.data.code.length>0,
                                    "allow-clear": ""
                                  }, {
                                    prefix: _withCtx(() => [
                                      _createVNode(_component_SafetyCertificateOutlined, { class: "input_icon" })
                                    ]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["value", "maxlength", "show-count"])
                                ]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_col, {
                            offset: 1,
                            span: 10
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                danger: "",
                                loading: $data.request.intercept.auth,
                                disabled: $data.setTime.countdown,
                                onClick: $options.getAuthCode,
                                block: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString($data.expand.countdown.text), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["loading", "disabled", "onClick"])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_checkbox, {
                            checked: $data.expand.protocol,
                            "onUpdate:checked": _cache[3] || (_cache[3] = ($event: any) => (($data.expand.protocol) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 我已阅读并同意账号注销协议，理解注销后账号、企业、应用、表单、附件、第三方绑定等信息可能无法恢复。 ")
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["checked"])
                        ]),
                        _: 1 /* STABLE */
                      }),
                      _createVNode(_component_a_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                danger: "",
                                loading: $data.request.intercept.submit,
                                onClick: $options.submit,
                                block: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 确认注销 ")
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["loading", "onClick"])
                            ]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "link",
                                class: "button_register",
                                onClick: $options.back,
                                block: ""
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 暂不注销 ")
                                ]),
                                _: 1 /* STABLE */
                              }, 8 /* PROPS */, ["onClick"])
                            ]),
                            _: 1 /* STABLE */
                          })
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["model", "rules"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          })
        ])
      ])
    ])
  ]))
}